import { Component, OnInit , ViewChild} from '@angular/core';
import { Product, Category } from './product';
import { ProductsService } from './products.service';
// import { FavoritesService } from './favorites.service';
import { ActivatedRoute } from '@angular/router';
import {
  Router,
  NavigationStart,
  NavigationEnd,
  NavigationError,
  NavigationCancel,
  RoutesRecognized,
  ResolveStart,
  ResolveEnd
} from "@angular/router";
import { PageEvent } from '@angular/material';
import { ControlsService } from '../controls.service';
import { Observable } from 'rxjs/Observable';
import { zip } from 'rxjs/observable/zip';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { interval } from "rxjs/observable/interval";
import { map, switchMap, publish, tap, take, filter, throttle} from 'rxjs/operators';
import { distinctUntilChanged } from 'rxjs/operators';
import { empty } from 'rxjs/observable/empty';
import { from } from 'rxjs/observable/from';
import { Query } from '../products/query';
import { takeWhile } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ConfigurationService } from '../configuration.service';
import { Configuration } from '../configuration';
import { MatGridList, MatPaginator } from "@angular/material";
import {MediaChange, ObservableMedia} from '@angular/flex-layout';

@Component({
  selector: "app-products",
  templateUrl: "./products.component.html",
  styleUrls: ["./products.component.scss"]
})
export class ProductsComponent implements OnInit {
  @ViewChild(MatPaginator)
  paginator: MatPaginator;

  // MatPaginator Inputs
  fileCount = 100;
  pageSize = 100;
  pageSizeOptions = [5, 10, 25, 100];
  // MatPaginator Output
  pageEvent: PageEvent;
  nbCols: number = 1;
  // pageIndex: number = 0;
  dataLoading: boolean = true;

  paginationSubject: BehaviorSubject<PageEvent> = new BehaviorSubject<
    PageEvent
  >({ pageIndex: 0, pageSize: 100, length: 100 });
  config: Configuration;

  products: Product[] = [];
  currentCategory: Category = {};
  test: any;

  private freeMod = <any>combineLatest(
    this.route.params,
    this.paginationSubject, //need to reset this pagination without trigger fresh call,
    (
      params: any,
      pagination: PageEvent
    ) => {
      return params.id
        ? ({
            category: +params.id || null,
            page: pagination.pageIndex + 1,
            limit: pagination.pageSize
          } as Query)
        : {};
    }
  ).pipe(
    distinctUntilChanged(),
    tap(() => {
      this.dataLoading = true;
    }),
    takeWhile(ret => ret.hasOwnProperty("category")),
    switchMap(
      (filter: any) =>
        filter.hasOwnProperty("category")
          ? this.productsService.getProducts(filter)
          : from([])
    ),
    publish()
  );

  constructor(
    private productsService: ProductsService,
    private route: ActivatedRoute,
    private cs: ControlsService,
    private configurationService: ConfigurationService,
    private media: ObservableMedia,
    private router: Router
  ) {
    this.config = configurationService.getConfigurationCache();
  }

  ngOnInit() {
    this.router.events.subscribe(val => {
      // if navigation event has started
      if (val instanceof NavigationStart) {
        this.dataLoading = true;
      }
      // if navigation has resolved
      if (val instanceof ResolveEnd) {
        this.dataLoading = false;
      }
    });

    this.route.params
      .pipe(
        filter((params: any) => params.id),
        switchMap(p => this.productsService.getCatoriesSingle(+p["id"]))
      )
      .subscribe((foundCategory: Category) => {
        // reset values up from product list
        this.fileCount = foundCategory.fileCount;
        // this.pageIndex = 0;
        this.paginator.pageIndex = 0;
        this.paginationSubject.next({
          pageIndex: 0,
          pageSize: 100,
          length: 100
        });

        this.currentCategory = foundCategory;
      });

    this.media.subscribe((change: MediaChange) => {
      this.updateGrids(change.mqAlias);
    });

    this.configurationService
      .getConfigurationSubject()
      .subscribe((config: Configuration) => {
        if (config.license) this.config = config;
      });

    // this.route.data
    // .subscribe((data: { categoryProducts: any }) => {
    //   this.products = data.categoryProducts.data;
    //   this.length = data.categoryProducts.total;
    //   if(data.categoryProducts){
    //     setTimeout(() => {
    //       this.freeMod.connect();
    //   }, 1000);
    //     }
    // });

    this.freeMod.subscribe(
      (value: any) => {
        if (value.data && value.data.length) {
          this.products = value.data;
          this.dataLoading = false;
        }
      },
      err => {},
      () => console.log("This is how it ends!")
    );
    this.freeMod.connect();
  }

  private updateGrids(breakpoint: string): void {
    let nbCols = 1;
    if (breakpoint == "xs") nbCols = 1;
    if (breakpoint == "sm") nbCols = 3;
    if (breakpoint == "md") nbCols = 4;
    if (breakpoint == "lg") nbCols = 6;
    if (breakpoint == "xl") nbCols = 8;

    this.nbCols = nbCols;
  }

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    this.pageSizeOptions = setPageSizeOptionsInput.split(",").map(str => +str);
  }

  onPaginateChange(event: PageEvent) {
    this.paginationSubject.next(event);
  }
}



// WEBPACK FOOTER //
// ./src/app/products/products.component.ts



// WEBPACK FOOTER //
// ./src/app/products/products.component.ts